export default {
  heading: 'Playfair Display, serif',
  body: 'Raleway, san-serif',
  monospace: 'Menlo, monospace',
  display: 'Petit Formal Script, cursive',
  googleFonts: [
    'Raleway:100,200,300,400,500,600,700,800,900',
    'Playfair Display:400,500,600,700,800,900',
    'Petit Formal Script'
  ]
  // customFamilies: [''],
  // customUrls: [''],
}
